import { CSSObject, keyframes } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const tutorialPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(166,200,255,0.7), 0 0 0 0 rgba(166,200,255,0.7);
  }
  40% {
    box-shadow: 0 0 0 25px rgba(166,200,255,0.0), 0 0 0 0 rgba(166,200,255,0.7);
  }
  80% {
    box-shadow: 0 0 0 25px rgba(166,200,255,0.0), 0 0 0 15px rgba(166,200,255,0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(166,200,255,0.0), 0 0 0 15px rgba(166,200,255,0);
  }
`;

export const useStyles = (...props: any) =>
  ({
    body2Medium: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    body2bold: {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      letterSpacing: "0.1px"
    },
    body3Regular: {
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "16px",
      letterSpacing: "0.4px",

      "& .MuiTypography-root": {
        letterSpacing: "0.4px"
      }
    },
    body3Medium: {
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "16px",
      letterSpacing: "0.4px",
      "& .MuiTypography-root": {
        letterSpacing: "0.4px"
      }
    },
    body4Medium: {
      fontSize: "10px",
      fontWeight: 500,
      lineHeight: "12px",
      letterSpacing: "1px"
    },
    logo: {
      display: "flex",
      justifyContent: "space-between",
      cursor: "pointer"
    },
    pageLayout: {
      display: "flex",
      width: `100%`
    },
    flexbox: {
      display: "flex",
      alignItems: "center"
    },
    verticalSeparator: {
      alignSelf: "stretch",
      flexShrink: "0",
      width: "1px",
      background: colors?.gray100,
      margin: props[0]?.separatorMargin ?? "0 16px"
    },
    customTab: {
      textTransform: "none",
      minHeight: "44px",
      minWidth: "164px",
      fontSize: "16px",
      lineHeight: "20px",
      letterSpacing: "0.15px",
      color: colors?.textPlaceholder,
      fontWeight: 500,

      "@media(max-width: 839px)": {
        flex: "1"
      },
      "@media(max-width: 599px)": {
        minWidth: "164px"
      },

      "&.Mui-selected": {
        color: colors?.textDark
      },
      "&:hover": {
        background: colors?.gray50,
        boxShadow: `inset 0px -2px 0px ${colors?.gray300}`
      },

      "&.Mui-disabled": {
        color: colors?.textDisabled
      }
    },
    tabsHolder: { minHeight: "44px" },

    tutorialHighlight: {
      outline: `3px solid ${colors.blue700}`,
      borderRadius: "4px",
      animation: `${tutorialPulse} 2s linear infinite`,
      zIndex: 1000
    },

    pulsatingHighlight: {
      outline: `3px solid ${colors.blue400}`,
      borderRadius: "4px",
      animation: `${tutorialPulse} 4s linear infinite`
    },

    scrollableCardContainer: {
      height: "100%",
      overflowY: "auto",
      scrollbarGutter: "stable",
      marginRight: "-16px"
    }
  }) as CSSObject;
